import React, { useState } from 'react';
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/business/bg1.jpg'
import bg2 from '../../assets/images/business/bg2.jpg'
import bg3 from '../../assets/images/business/bg3.jpg'
import testi from '../../assets/images/bg/testi.jpg'
import about from '../../assets/images/business/about.png'

import Navbar from "../../components/navbar";
import Blog from '../../components/blog';
import FooterTopTwo from '../../components/footerTopTwo';
import Footer from '../../components/footer';
import ScrollTop from '../../components/scrollTop';

import { Carousel } from 'react-responsive-carousel';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css'

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

import { MdOutlineCheckCircle, FiArrowRight, FiMail } from '../../assets/icons/icons'

import { servicesData, clientData, teamData, portfolioData } from '../../data/data';

export default function IndexBusiness(){
    let [isOpen, setOpen] = useState(false);

    let settings = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
      };
      let settings2 = {
        container: '.tiny-single-item',
        items: 1,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 16,
        responsive: {
            992: {
                items: 5
            },

            767: {
                items: 2
            },
            

            320: {
                items: 1
            },
        },
      };

    return(
        <>
        <Navbar navLight={true}/>
        <section className="home-slider position-relative">
            <div className="carousel slide carousel-fade">
                <Carousel autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false} showThumbs={false}>
                    <div>
                        <div className="bg-home bg-animation-left d-flex align-items-center" style={{backgroundImage:`url(${bg1})`}}>
                            <div className="bg-overlay"></div>
                            <div className="container">
                                <div className="row justify-content-center mt-5">
                                    <div className="col-12">
                                        <div className="title-heading text-center mt-4">                                    
                                            <h1 className="display-4 text-white title-dark fw-bold mb-3">Lead your business <br/> success with landflow</h1>
                                            <p className="para-desc text-white-50 mx-auto para-dark">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                                            <div className="mt-4">
                                                <Link to="#" className="btn btn-primary">About Us</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="bg-home bg-animation-left d-flex align-items-center" style={{backgroundImage:`url(${bg2})`}}>
                            <div className="bg-overlay"></div>
                            <div className="container">
                                <div className="row justify-content-center mt-5">
                                    <div className="col-12">
                                        <div className="title-heading text-center mt-4">
                                            <h1 className="display-4 text-white title-dark fw-bold mb-3">Start your successful <br/> business with landflow</h1>
                                            <p className="para-desc text-white-50 mx-auto para-dark">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                                            <div className="mt-4">
                                                <Link to="#" className="btn btn-primary">Contact Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="bg-home bg-animation-left d-flex align-items-center" style={{backgroundImage:`url(${bg3})`}}>
                            <div className="bg-overlay"></div>
                            <div className="container">
                                <div className="row justify-content-center mt-5">
                                    <div className="col-12">
                                        <div className="title-heading text-center mt-4">
                                            <h1 className="display-4 text-white title-dark fw-bold mb-3">Join best enterprises <br/> in france and europe</h1>
                                            <p className="para-desc text-white-50 mx-auto para-dark">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                                            <div className="mt-4">
                                                <Link to="#" className="btn btn-primary">Learn More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <div className="position-relative me-lg-5">
                            <img src={about} className="img-fluid" alt=""/>
                            <div className="play-icon">
                                <Link to="#"  onClick={() => setOpen(true)} className="lightbox play-btn video-play-icon">
                                    <i className="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>
                                </Link>
                            </div>
                            <ModalVideo
                                channel="youtube"
                                youtube={{ mute: 0, autoplay: 0 }}
                                isOpen={isOpen}
                                videoId="yba7hPeTSjk"
                                onClose={() => setOpen(false)} 
                            />
                        </div>
                    </div>

                    <div className="col-md-6 mt-4 mt-sm-0 pt-4 pt-sm-0">
                        <div className="section-title">
                            <span className="badge rounded-pill bg-soft-primary">Who we are ?</span>
                            <h4 className="title mt-3 mb-4">Professional Investment & <br/> strategy company</h4>
                            <p className="text-muted para-desc mb-0">Dummy text is also used to demonstrate the appearance of different typefaces and layouts, and in general the content of dummy text is nonsensical.</p>
                            <ul className="list-unstyled text-muted mb-0 mt-4">
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Organize your data</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Work with any team</li>
                                <li className="list-inline-item me-lg-5 me-4 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Business analytics</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Our Services</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {servicesData.map((item,index) =>{
                        let Icon  = item.icon
                        return(
                        <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                            <div className="card features feature-primary rounded p-4 text-center border-0">
                                <div className="icon text-center rounded-md mx-auto">
                                    <h3 className="mb-0"><Icon/></h3>
                                </div>
                                <div className="card-body p-0 mt-4">
                                    <h5>{item.title}</h5>
                                    <p className="text-muted mb-0">{item.desc}</p>
                                    <div className="mt-2">
                                        <Link to="#" className="link">Read More<FiArrowRight className="fea icon-sm"/></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>

            <div className="container-fluid mt-100 mt-60">
                <div className="py-5 rounded" style={{backgroundImage:`url(${testi})`, backgroundPosition:'center'}}>
                    <div className="container">
                        <div className="row py-md-5 py-4">
                            <div className="col-lg-4 col-md-6">
                                <div className="bg-white rounded px-4 py-5">
                                    <div className="tiny-single-item">
                                        <TinySlider settings={settings}>
                                            {clientData.map((item, index) =>{
                                                return(
                                                <div className="tiny-slide" key={index}>
                                                    <div className="customer-testi">
                                                        <p className="text-muted fst-italic">{item.desc}</p>
                                                        <div className="d-flex align-items-center mt-4">
                                                            <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                            <div className="flex-1 ms-3">
                                                                <h6 className="text-primary mb-0">{item.name}</h6>
                                                                <small className="text-muted">{item.title}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )
                                            })}
                                        </TinySlider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Our Team</h6>
                            <h4 className="title mb-4">Creative Team Members</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {teamData.slice(0,4).map((item, index) =>{
                        return(
                            <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="card text-center team border-0 shadow rounded overflow-hidden">
                                    <img src={item.image} className="img-fluid" alt=""/>
                                    <div className="card-body py-3 content">
                                        <h5 className="mb-0">{item.name}</h5>
                                        <h6 className="text-muted mb-0">{item.title}</h6>
                                    </div>
                                    <ul className="list-unstyled team-social mb-0">
                                        <li><Link to="mailto:contact@example.com" className="btn btn-icon btn-pills btn-soft-primary"><FiMail className="icons"/></Link></li>
                                    </ul>
                                </div>
                            </div>
                        )
                    })}

                    <div className="col-12 text-center mt-4 pt-2">
                        <div className="alert alert-light alert-pills" role="alert">
                            <span className="badge bg-danger rounded-pill me-1">Jobs</span>
                            <span className="content">We Are Hiring <Link to="#" className="text-primary"> Send your CV / Resume</Link></span>
                         </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <span className="badge rounded-pill bg-soft-primary h6">Portfolio</span>
                            <h4 className="title mt-2 mb-4">Latest Projects & Works</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4 pt-2" id="slider-container">
                <div className="row slider-row-width">
                    <div className="col-12">
                        <div className="swiper-container">
                            <div className="swiper-wrapper">
                                <TinySlider settings={settings2}>
                                    {portfolioData.map((item, index) =>{
                                        return(
                                        <div className="swiper-slide" key={index}>
                                            <div className={item.borderClass}>
                                                <div className="card-body p-0">
                                                    <Link to="#"><img src={item.image} className="img-fluid work-image" alt=""/></Link>
                                                    <div className="content p-4">
                                                        <h5 className="mb-0"><Link to="#" className="text-dark title">{item.title}</Link></h5>
                                                        <h6 className="text-muted tag mb-0">{item.desc}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    })}
                                </TinySlider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">News</h6>
                            <h4 className="title mb-4">Latest News or Blogs</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
                <Blog/>
            </div>
        </section>
        <FooterTopTwo/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}